/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'no-avatar': {
    width: 20,
    height: 23,
    viewBox: '0 0 20 23',
    data: '<path pid="0" d="M14.42 12.246a8.736 8.736 0 014.04 3.229A8.908 8.908 0 0120 20.447v1.693c0 .475-.38.86-.85.86H.85a.855.855 0 01-.85-.86v-1.693a8.908 8.908 0 011.54-4.972 8.736 8.736 0 014.04-3.229.842.842 0 01.964.258c.785.992 1.95 1.6 3.204 1.672a4.392 4.392 0 003.368-1.3l.34-.343a.844.844 0 01.964-.287zM4.39 5.678a5.747 5.747 0 011.652-4.007A5.606 5.606 0 0110 0c1.487 0 2.915.598 3.966 1.663a5.713 5.713 0 011.643 4.015 5.71 5.71 0 01-1.643 4.015A5.572 5.572 0 0110 11.356a5.572 5.572 0 01-3.966-1.663 5.71 5.71 0 01-1.643-4.015z" _fill="#FFF" fill-rule="evenodd" opacity=".5"/>'
  }
})
